/**
 * Novedades del sistema, redactadas para quien las lee en pantalla.
 *
 * Fuente única: la consume el panel de administración (todo) y el dashboard de
 * empresa (sólo lo que le importa al cliente).
 *
 * El número de versión NO vive acá: es uno solo para el front y el back, sale
 * de Backend/version.py y llega por la API. Acá sólo se etiqueta a qué release
 * pertenece cada entrada, y tiene que coincidir. El detalle técnico de cada
 * versión va en el CHANGELOG.md del backend.
 *
 * audiencia: 'todos'  -> se le muestra también al cliente
 *            'admin'  -> sólo en el panel de administración
 * pos: true           -> además se le muestra al cajero en el punto de venta
 */

export const RELEASES = [
  {
    version: 'v1.12.0',
    fecha: '2026-11-03',
    titulo: 'Centro de carga de productos y líneas de negocio',
    items: [
      {
        tag: 'PRODUCTOS',
        audiencia: 'todos',
        texto:
          'Centro de carga: subí una lista de proveedor o una factura y el sistema ' +
          'propone qué productos ya existen, cuáles son nuevos y a qué precio; revisás ' +
          'fila por fila y aplicás todo junto. Desde una factura podés registrar la compra.',
      },
      {
        tag: 'PRODUCTOS',
        audiencia: 'todos',
        texto:
          'Cada producto tiene su pestaña Historial (quién cambió qué y cuándo, incluidos ' +
          'precios y costos) y su pestaña Proveedores con el último costo de cada uno.',
      },
      {
        tag: 'PRODUCTOS',
        audiencia: 'todos',
        texto:
          'Control de carga para revisar lo que se cargó y encontrar productos sin foto, ' +
          'sin costo, vendidos por debajo del costo, sin IVA o repetidos, y Fotos para ' +
          'subir una carpeta de imágenes y ' +
          'asignarlas a los productos por nombre o código.',
      },
      {
        tag: 'PRODUCTOS',
        audiencia: 'todos',
        texto:
          'Al cargar un producto se elige su alícuota de IVA (21%, 10,5%...) y el sistema ' +
          'asigna solo la cuenta contable que corresponde.',
      },
      {
        tag: 'CONTABILIDAD',
        audiencia: 'todos',
        texto:
          'Líneas de negocio: agrupá tus categorías (por ejemplo Juguetería o Librería) ' +
          'para ver ventas, mercaderías y costo de lo vendido separados por línea. Se ' +
          'configura en Contabilidad → Líneas de negocio.',
      },
      {
        tag: 'SEGURIDAD',
        audiencia: 'admin',
        texto:
          'Las presentaciones de un producto ya no se pueden ver ni editar desde otra empresa.',
      },
    ],
  },
  {
    version: 'v1.11.0',
    fecha: '2026-11-02',
    titulo: 'Caja por usuario, Mi plan e integraciones',
    items: [
      {
        tag: 'CAJA',
        audiencia: 'todos',
        pos: true,
        texto:
          'Cada usuario puede tener una sola caja abierta en toda la empresa. Si ya ' +
          'tenés una abierta en otra sucursal, el sistema te avisa cuál es para que la ' +
          'cierres antes. Cada cajera necesita su propio usuario.',
      },
      {
        tag: 'CAJA',
        audiencia: 'todos',
        pos: true,
        texto:
          'Al cerrar la caja se cierra la sesión, también en las otras pestañas. Al abrir ' +
          'ves a nombre de quién se abre y, si no sos vos, el botón "No soy yo".',
      },
      {
        tag: 'SUSCRIPCIÓN',
        audiencia: 'todos',
        texto:
          'Nueva pantalla Mi plan: tu plan, los módulos y servicios que tenés, tu cuenta ' +
          'con los resúmenes y recibos en PDF, y la opción de pedir un cambio de plan.',
      },
      {
        tag: 'INTEGRACIONES',
        audiencia: 'todos',
        texto:
          'Podés ocultar un producto de una integración (por ejemplo CantinApp) sin ' +
          'darlo de baja en la sucursal. Y un producto dado de baja en la sucursal ya no ' +
          'aparece en las integraciones.',
      },
      {
        tag: 'PRODUCTOS',
        audiencia: 'todos',
        texto:
          'Para eliminar todos los productos de un proveedor ahora hay que escribir su ' +
          'nombre, para evitar borrados por error. La búsqueda de productos encuentra ' +
          'cada palabra por separado.',
      },
      {
        tag: 'CORRECCIÓN',
        audiencia: 'todos',
        texto:
          'La ficha del proveedor muestra su condición de IVA real, y Alta Masiva ' +
          'muestra el resultado de cada fila.',
      },
      {
        tag: 'CHEQUES',
        audiencia: 'admin',
        texto:
          'Cartera de cheques recibidos como servicio adicional (cartera_cheques): cobrar, ' +
          'depositar, endosar y rechazar. CHEQUE necesita la cuenta "Valores a depositar" ' +
          'en cada sucursal.',
      },
      {
        tag: 'SEGURIDAD',
        audiencia: 'admin',
        texto:
          'Aislamiento entre empresas en productos, catálogos de proveedor, imágenes, ' +
          'inventario y recetas de producción. Tienda online: venta mayorista por bulto.',
      },
    ],
  },
  {
    version: 'v1.10.0',
    fecha: '2026-09-20',
    titulo: 'Pagos a proveedores y flujo de caja',
    items: [
      {
        tag: 'PROVEEDORES',
        audiencia: 'todos',
        texto:
          'Ahora podés pagarle a un proveedor un importe cualquiera desde su Cuenta ' +
          'Corriente: el sistema lo imputa a las facturas más viejas y lo que sobra ' +
          'queda a cuenta para el próximo pago. Antes de confirmar ves qué facturas cancela.',
      },
      {
        tag: 'PROVEEDORES',
        audiencia: 'todos',
        texto:
          'Al pagar una factura puntual ya no se rechaza el excedente: queda a cuenta ' +
          'del proveedor.',
      },
      {
        tag: 'CONTABILIDAD',
        audiencia: 'todos',
        texto:
          'Nueva forma de pago "PAGO DIFERIDO" para cheques y echeq: se asienta contra ' +
          'la cuenta que le asignes en Sucursal → Contabilidad → Formas de pago (por ' +
          'ejemplo "Cheques a pagar"). Hasta que no tenga cuenta no aparece al pagar.',
      },
      {
        tag: 'REPORTES',
        audiencia: 'todos',
        texto:
          'En Flujo de caja cada tipo de gasto y cada proveedor se despliega con un click ' +
          'y muestra los gastos o pagos que lo componen (fecha, descripción, sucursal, importe).',
      },
    ],
  },
  {
    version: 'v1.9.0',
    fecha: '2026-09-18',
    titulo: 'Caja, sucursal y reportes',
    items: [
      {
        tag: 'CAJA',
        audiencia: 'todos',
        pos: true,
        texto:
          'Cerrar la caja es más simple: contás los billetes, tocás Continuar y recién ' +
          'ahí ves si sobra o falta. Después elegís Cambio de turno o Finalizar jornada.',
      },
      {
        tag: 'CAJA',
        audiencia: 'todos',
        pos: true,
        texto:
          'Si una caja quedó abierta de otro día, al entrar vas directo a cerrarla. ' +
          'Hasta que no la cierres no se puede vender ni mover plata con esa caja.',
      },
      {
        tag: 'CAJA',
        audiencia: 'todos',
        pos: true,
        texto:
          'La pantalla de caja muestra quién la abrió y desde cuándo, y los ingresos y ' +
          'retiros del turno. Elegir sucursal y caja también cambió de aspecto.',
      },
      {
        tag: 'SUCURSAL',
        audiencia: 'todos',
        texto:
          'El inicio de cada sucursal ahora es real: ventas de hoy y del mes, cajas ' +
          'abiertas (en rojo si quedaron de otro día), efectivo en cajas, últimas ventas y compras.',
      },
      {
        tag: 'INICIO',
        audiencia: 'todos',
        texto:
          'Buscador en la home (Ctrl+K o ⌘K): escribí una pantalla, un producto, un cliente ' +
          'o una sucursal y entrás sin recorrer menús.',
      },
      {
        tag: 'REPORTES',
        audiencia: 'todos',
        texto:
          'Los filtros de período son iguales en todos los reportes (Hoy, Ayer, 7 días, ' +
          'Este mes, Mes pasado, Personalizado) y Métricas de ventas compara con el período anterior.',
      },
      {
        tag: 'CONFIGURACIÓN',
        audiencia: 'todos',
        texto:
          'Nuevo parámetro de caja "Movimientos visibles para empleados": decidís si el ' +
          'cajero ve la lista de ingresos y retiros de su turno. Arranca apagado.',
      },
      {
        tag: 'CORRECCIÓN',
        audiencia: 'todos',
        texto:
          'Ventas por hora y Métricas de ventas contaban distinto: las ventas de madrugada ' +
          'iban al día siguiente en el gráfico. Ahora los dos usan el día de la jornada.',
      },
      {
        tag: 'AFIP',
        audiencia: 'admin',
        texto:
          'Toda solicitud de CAE informa la condición de IVA del receptor (RG 5616, ' +
          'obligatoria desde el 01/12/2026).',
      },
    ],
  },
  {
    version: 'v1.8.0',
    fecha: '2026-09-09',
    titulo: 'Clientes',
    items: [
      {
        tag: 'CORRECCIÓN',
        audiencia: 'todos',
        texto:
          '"Eliminar cliente" no funcionaba: con comprobantes daba error y sin ellos ' +
          'dejaba la cuenta corriente colgada. Ahora un cliente con movimientos se archiva ' +
          'conservando su historial, y uno que nunca se usó se elimina. Con saldo pendiente ' +
          'no se deja eliminar.',
      },
      {
        tag: 'CLIENTES',
        audiencia: 'todos',
        texto:
          'Ya se puede editar la razón social y cambiar un cliente de persona a empresa. ' +
          'Antes la edición sólo guardaba el nombre de la persona.',
      },
      {
        tag: 'CLIENTES',
        audiencia: 'todos',
        texto:
          'El perfil distingue empresa de persona: muestra razón social y CUIT, o nombre y ' +
          'documento, con la condición de IVA y un aviso cuando falta el CUIT para facturar.',
      },
      {
        tag: 'CORRECCIÓN',
        audiencia: 'todos',
        texto:
          'Un cliente cargado como empresa no aparecía al buscarlo para hacerle un ' +
          'presupuesto: el buscador no miraba la razón social.',
      },
    ],
  },
  {
    version: 'v1.7.0',
    fecha: '2026-09-09',
    titulo: 'Ventas y clientes',
    items: [
      {
        tag: 'CORRECCIÓN',
        audiencia: 'todos',
        texto:
          'Ya no se puede remitir dos veces la misma mercadería. Antes, un remito emitido ' +
          'y todavía no entregado no descontaba del pendiente del pedido.',
      },
      {
        tag: 'REMITOS',
        audiencia: 'todos',
        texto:
          'Al crear un remito las cantidades vienen cargadas con lo que falta entregar. ' +
          'Las entregas parciales avisan cuándo una línea sale incompleta.',
      },
      {
        tag: 'ÓRDENES',
        audiencia: 'todos',
        texto:
          'Cada orden muestra cuánto se entregó, qué está en camino y qué falta. ' +
          'Las órdenes que ya entregaron todo se cierran solas con el estado "Entregada".',
      },
      {
        tag: 'VENTAS',
        audiencia: 'todos',
        texto:
          'Los listados de presupuestos, órdenes, remitos y pedidos online muestran el cliente, ' +
          'se buscan por cliente o número y se filtran por estado con un click.',
      },
      {
        tag: 'PRESUPUESTOS',
        audiencia: 'todos',
        texto:
          'El detalle muestra las condiciones de pago congeladas, el vencimiento y, en los ' +
          'pedidos online, la entrega y el estado del pago.',
      },
      {
        tag: 'CLIENTES',
        audiencia: 'todos',
        texto:
          'El alta distingue persona de empresa y pide sólo el nombre o la razón social. ' +
          'Los datos para facturar quedan para cuando hagan falta.',
      },
      {
        tag: 'CLIENTES',
        audiencia: 'todos',
        texto:
          'El listado distingue las empresas, muestra CUIT y condición de IVA, y se busca ' +
          'también por razón social o documento.',
      },
      {
        tag: 'PROVEEDORES',
        audiencia: 'todos',
        texto:
          'El alta de un proveedor le crea sola la cuenta contable. Antes fallaba la primera compra.',
      },
      {
        tag: 'DATOS',
        audiencia: 'admin',
        texto:
          'Comandos nuevos: cerrar_ordenes_entregadas, deducir_tipo_cliente (marca empresa o ' +
          'persona física según CUIT y nombre) y backfill_cuentas_proveedores. Los tres con dry-run.',
      },
      {
        tag: 'RENDIMIENTO',
        audiencia: 'admin',
        texto:
          'Los listados de ventas y clientes dejaron de serializar el detalle completo por fila. ' +
          'El listado de clientes pasó de una consulta por cliente a dos en total.',
      },
    ],
  },
];

/** Las novedades de la última versión, para la audiencia que corresponda. */
export function novedadesRecientes(audiencia = 'todos') {
  const ultima = RELEASES[0];
  if (!ultima) return [];
  if (audiencia === 'pos') return ultima.items.filter((item) => item.pos);
  return ultima.items.filter(
    (item) => audiencia === 'admin' || item.audiencia === 'todos',
  );
}

/** Versión de la última entrada, para saber si el usuario ya vio estas novedades. */
export function versionActual() {
  return RELEASES[0] ? RELEASES[0].version : '';
}
